import { createEntityAdapter } from '@reduxjs/toolkit';
import { ModalPayload, ModalsState } from './interfaces';
import { ModalStoreStatus } from './enums';

export const entityAdapter = createEntityAdapter<ModalPayload>({
  selectId: (data) => data.name,
});

export const initialState: ModalsState = entityAdapter.getInitialState({
  status: { [ModalStoreStatus.Loading]: [] },
});
